var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9857 10.5676L21.2139 9.5525L23.3081 7.70422C21.2501 5.15223 18.1393 3.52952 14.6585 3.52941C8.46769 3.52941 3.44906 8.66497 3.44906 15C3.44906 21.335 8.46769 26.4706 14.6585 26.4706C17.8047 26.4705 20.6463 25.1459 22.6841 23.0075L22.8786 22.7981L23.0058 22.6723C23.6619 22.0817 24.6618 22.083 25.3164 22.7042C25.9708 23.3256 26.0475 24.3462 25.521 25.06L25.4082 25.1988L25.1539 25.4719C22.4936 28.2633 18.7728 29.9999 14.6585 30C6.56283 30 -1.01779e-06 23.2843 -6.55671e-07 15C-2.93554e-07 6.71573 6.56283 -9.37049e-07 14.6585 -5.83176e-07C19.1866 0.000106776 23.2334 2.10312 25.9201 5.4001L28 3.56474L27.9857 10.5676Z",
    fill: "#9D9EB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.5cd8f8550ed392554af22d2a296fd944.svg";
export { ForwardRef as ReactComponent };